import React ,{useState} from 'react';
import './messenger.css'
import {devices} from "../../utils/devices";
import {useSelector} from "react-redux";
import close from "../../res/img/close.png";

const Messenger = () => {
    const [ messengerModal , setMessengerModal] = useState(false)
    const setting = useSelector(state => state.setting.setting )
    const numbers = setting && setting.number_list && JSON.parse(setting.number_list)
    const messenger = () => {
        let device = devices();
            return (
                <div className={"messenger"}>
                    <div className={`messenger-list ${messengerModal ? "show" : "hidden"}`}>
                        <div className={"messenger-list-top"}>
                            <span>ارتباط با ما در واتساپ</span>
                        </div>
                        <div className={"messenger-list-down"}>
                            {
                                numbers && numbers.map((item , index) => {
                                    return(
                                        <div onClick={() => {window.location.assign(device === 'desktop'? `https://web.whatsapp.com/send?phone=${item}` : `https://api.whatsapp.com/send?phone=${item}`)}} className={"messenger-list-down-item"}>
                                            <img src="https://img.icons8.com/ios-filled/50/000000/headset.png"/>
                                            <span>{`اپراتور شماره ${index + 1}`}</span>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <a className={"messenger-icon"} onClick={()=>{setMessengerModal(!messengerModal)}} target="_blank">
                        {
                            !messengerModal ? <img src="https://img.icons8.com/color/48/000000/whatsapp--v6.png"/> : <img src={close}/>
                        }

                    </a>
                    <div className={`messenger-we-here ${!messengerModal ? "show" : "hidden"}`} >
                        کمک نیاز دارید؟ چت از طریق واتساپ
                    </div>
                </div>
            )
    }
    return (
        <>
            {messenger()}
        </>
    );
};

export default Messenger;